import { useHotkeys } from 'react-hotkeys-hook';

import usePrimaryNavStore from '@/components/shared/PrimaryNavDrawer/PrimaryNavStore';

const GlobalHotKeys = () => {
  const { setSwitchAccountModalIsOpen } = usePrimaryNavStore();
  useHotkeys(
    'alt+s',
    () => {
      setSwitchAccountModalIsOpen(true);
    },
    [],
  );

  return null;
};

export default GlobalHotKeys;
